/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Swarmind API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { ApiStoreHistoryPostInput } from '../models';
// @ts-ignore
import { ModelsModel } from '../models';
// @ts-ignore
import { RestErrResponse } from '../models';
// @ts-ignore
import { StoreMessage } from '../models';
/**
 * StoreApi - axios parameter creator
 * @export
 */
export const StoreApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes the whole chat for that user and namespace (application tag)
         * @summary Delete chat
         * @param {string} namespace 
         * @param {string} chat 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChat: async (namespace: string, chat: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'namespace' is not null or undefined
            assertParamExists('deleteChat', 'namespace', namespace)
            // verify required parameter 'chat' is not null or undefined
            assertParamExists('deleteChat', 'chat', chat)
            const localVarPath = `/store/history/{namespace}/{chat}`
                .replace(`{${"namespace"}}`, encodeURIComponent(String(namespace)))
                .replace(`{${"chat"}}`, encodeURIComponent(String(chat)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns messages for that user, namespace (application tag) and chat name
         * @summary Get messages list
         * @param {string} namespace 
         * @param {string} chat 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatHistory: async (namespace: string, chat: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'namespace' is not null or undefined
            assertParamExists('getChatHistory', 'namespace', namespace)
            // verify required parameter 'chat' is not null or undefined
            assertParamExists('getChatHistory', 'chat', chat)
            const localVarPath = `/store/history/{namespace}/{chat}`
                .replace(`{${"namespace"}}`, encodeURIComponent(String(namespace)))
                .replace(`{${"chat"}}`, encodeURIComponent(String(chat)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retreives message id and model name pairs for the chat
         * @summary Get chat message id and model pairs
         * @param {string} namespace 
         * @param {string} chat 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatModelPairs: async (namespace: string, chat: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'namespace' is not null or undefined
            assertParamExists('getChatModelPairs', 'namespace', namespace)
            // verify required parameter 'chat' is not null or undefined
            assertParamExists('getChatModelPairs', 'chat', chat)
            const localVarPath = `/store/models/pairs/{namespace}/{chat}`
                .replace(`{${"namespace"}}`, encodeURIComponent(String(namespace)))
                .replace(`{${"chat"}}`, encodeURIComponent(String(chat)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retreives list of used models for the chat
         * @summary Get list of used models in the chat
         * @param {string} namespace 
         * @param {string} chat 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatUniqueModels: async (namespace: string, chat: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'namespace' is not null or undefined
            assertParamExists('getChatUniqueModels', 'namespace', namespace)
            // verify required parameter 'chat' is not null or undefined
            assertParamExists('getChatUniqueModels', 'chat', chat)
            const localVarPath = `/store/models/unique/{namespace}/{chat}`
                .replace(`{${"namespace"}}`, encodeURIComponent(String(namespace)))
                .replace(`{${"chat"}}`, encodeURIComponent(String(chat)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns chat names for that user and namespace (application tag)
         * @summary Get chat list
         * @param {string} namespace 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChats: async (namespace: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'namespace' is not null or undefined
            assertParamExists('getChats', 'namespace', namespace)
            const localVarPath = `/store/chats/{namespace}`
                .replace(`{${"namespace"}}`, encodeURIComponent(String(namespace)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates messages for that user, namespace (application tag) and chat name.    Null message will delete a message with such ID.    Messages with the same ID will be overwritten (updated).
         * @summary Update messages
         * @param {string} namespace 
         * @param {string} chat 
         * @param {ApiStoreHistoryPostInput} [apiStoreHistoryPostInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChatHistory: async (namespace: string, chat: string, apiStoreHistoryPostInput?: ApiStoreHistoryPostInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'namespace' is not null or undefined
            assertParamExists('updateChatHistory', 'namespace', namespace)
            // verify required parameter 'chat' is not null or undefined
            assertParamExists('updateChatHistory', 'chat', chat)
            const localVarPath = `/store/history/{namespace}/{chat}`
                .replace(`{${"namespace"}}`, encodeURIComponent(String(namespace)))
                .replace(`{${"chat"}}`, encodeURIComponent(String(chat)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiStoreHistoryPostInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StoreApi - functional programming interface
 * @export
 */
export const StoreApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StoreApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes the whole chat for that user and namespace (application tag)
         * @summary Delete chat
         * @param {string} namespace 
         * @param {string} chat 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteChat(namespace: string, chat: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteChat(namespace, chat, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['StoreApi.deleteChat']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Returns messages for that user, namespace (application tag) and chat name
         * @summary Get messages list
         * @param {string} namespace 
         * @param {string} chat 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatHistory(namespace: string, chat: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StoreMessage>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatHistory(namespace, chat, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['StoreApi.getChatHistory']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Retreives message id and model name pairs for the chat
         * @summary Get chat message id and model pairs
         * @param {string} namespace 
         * @param {string} chat 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatModelPairs(namespace: string, chat: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: ModelsModel; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatModelPairs(namespace, chat, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['StoreApi.getChatModelPairs']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Retreives list of used models for the chat
         * @summary Get list of used models in the chat
         * @param {string} namespace 
         * @param {string} chat 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatUniqueModels(namespace: string, chat: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ModelsModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatUniqueModels(namespace, chat, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['StoreApi.getChatUniqueModels']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Returns chat names for that user and namespace (application tag)
         * @summary Get chat list
         * @param {string} namespace 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChats(namespace: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChats(namespace, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['StoreApi.getChats']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Updates messages for that user, namespace (application tag) and chat name.    Null message will delete a message with such ID.    Messages with the same ID will be overwritten (updated).
         * @summary Update messages
         * @param {string} namespace 
         * @param {string} chat 
         * @param {ApiStoreHistoryPostInput} [apiStoreHistoryPostInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateChatHistory(namespace: string, chat: string, apiStoreHistoryPostInput?: ApiStoreHistoryPostInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateChatHistory(namespace, chat, apiStoreHistoryPostInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['StoreApi.updateChatHistory']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * StoreApi - factory interface
 * @export
 */
export const StoreApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StoreApiFp(configuration)
    return {
        /**
         * Deletes the whole chat for that user and namespace (application tag)
         * @summary Delete chat
         * @param {StoreApiDeleteChatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChat(requestParameters: StoreApiDeleteChatRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteChat(requestParameters.namespace, requestParameters.chat, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns messages for that user, namespace (application tag) and chat name
         * @summary Get messages list
         * @param {StoreApiGetChatHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatHistory(requestParameters: StoreApiGetChatHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<StoreMessage>> {
            return localVarFp.getChatHistory(requestParameters.namespace, requestParameters.chat, options).then((request) => request(axios, basePath));
        },
        /**
         * Retreives message id and model name pairs for the chat
         * @summary Get chat message id and model pairs
         * @param {StoreApiGetChatModelPairsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatModelPairs(requestParameters: StoreApiGetChatModelPairsRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: ModelsModel; }> {
            return localVarFp.getChatModelPairs(requestParameters.namespace, requestParameters.chat, options).then((request) => request(axios, basePath));
        },
        /**
         * Retreives list of used models for the chat
         * @summary Get list of used models in the chat
         * @param {StoreApiGetChatUniqueModelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatUniqueModels(requestParameters: StoreApiGetChatUniqueModelsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ModelsModel>> {
            return localVarFp.getChatUniqueModels(requestParameters.namespace, requestParameters.chat, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns chat names for that user and namespace (application tag)
         * @summary Get chat list
         * @param {StoreApiGetChatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChats(requestParameters: StoreApiGetChatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getChats(requestParameters.namespace, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates messages for that user, namespace (application tag) and chat name.    Null message will delete a message with such ID.    Messages with the same ID will be overwritten (updated).
         * @summary Update messages
         * @param {StoreApiUpdateChatHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChatHistory(requestParameters: StoreApiUpdateChatHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateChatHistory(requestParameters.namespace, requestParameters.chat, requestParameters.apiStoreHistoryPostInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StoreApi - interface
 * @export
 * @interface StoreApi
 */
export interface StoreApiInterface {
    /**
     * Deletes the whole chat for that user and namespace (application tag)
     * @summary Delete chat
     * @param {string} namespace 
     * @param {string} chat 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApiInterface
     */
    deleteChat(namespace: string, chat: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Returns messages for that user, namespace (application tag) and chat name
     * @summary Get messages list
     * @param {string} namespace 
     * @param {string} chat 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApiInterface
     */
    getChatHistory(namespace: string, chat: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StoreMessage>>;

    /**
     * Retreives message id and model name pairs for the chat
     * @summary Get chat message id and model pairs
     * @param {string} namespace 
     * @param {string} chat 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApiInterface
     */
    getChatModelPairs(namespace: string, chat: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: ModelsModel; }>;

    /**
     * Retreives list of used models for the chat
     * @summary Get list of used models in the chat
     * @param {string} namespace 
     * @param {string} chat 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApiInterface
     */
    getChatUniqueModels(namespace: string, chat: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ModelsModel>>;

    /**
     * Returns chat names for that user and namespace (application tag)
     * @summary Get chat list
     * @param {string} namespace 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApiInterface
     */
    getChats(namespace: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>>;

    /**
     * Updates messages for that user, namespace (application tag) and chat name.    Null message will delete a message with such ID.    Messages with the same ID will be overwritten (updated).
     * @summary Update messages
     * @param {string} namespace 
     * @param {string} chat 
     * @param {ApiStoreHistoryPostInput} [apiStoreHistoryPostInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApiInterface
     */
    updateChatHistory(namespace: string, chat: string, apiStoreHistoryPostInput?: ApiStoreHistoryPostInput, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for deleteChat operation in StoreApi.
 * @export
 * @interface StoreApiDeleteChatRequest
 */
export interface StoreApiDeleteChatRequest {
    /**
     * 
     * @type {string}
     * @memberof StoreApiDeleteChat
     */
    readonly namespace: string

    /**
     * 
     * @type {string}
     * @memberof StoreApiDeleteChat
     */
    readonly chat: string
}

/**
 * Request parameters for getChatHistory operation in StoreApi.
 * @export
 * @interface StoreApiGetChatHistoryRequest
 */
export interface StoreApiGetChatHistoryRequest {
    /**
     * 
     * @type {string}
     * @memberof StoreApiGetChatHistory
     */
    readonly namespace: string

    /**
     * 
     * @type {string}
     * @memberof StoreApiGetChatHistory
     */
    readonly chat: string
}

/**
 * Request parameters for getChatModelPairs operation in StoreApi.
 * @export
 * @interface StoreApiGetChatModelPairsRequest
 */
export interface StoreApiGetChatModelPairsRequest {
    /**
     * 
     * @type {string}
     * @memberof StoreApiGetChatModelPairs
     */
    readonly namespace: string

    /**
     * 
     * @type {string}
     * @memberof StoreApiGetChatModelPairs
     */
    readonly chat: string
}

/**
 * Request parameters for getChatUniqueModels operation in StoreApi.
 * @export
 * @interface StoreApiGetChatUniqueModelsRequest
 */
export interface StoreApiGetChatUniqueModelsRequest {
    /**
     * 
     * @type {string}
     * @memberof StoreApiGetChatUniqueModels
     */
    readonly namespace: string

    /**
     * 
     * @type {string}
     * @memberof StoreApiGetChatUniqueModels
     */
    readonly chat: string
}

/**
 * Request parameters for getChats operation in StoreApi.
 * @export
 * @interface StoreApiGetChatsRequest
 */
export interface StoreApiGetChatsRequest {
    /**
     * 
     * @type {string}
     * @memberof StoreApiGetChats
     */
    readonly namespace: string
}

/**
 * Request parameters for updateChatHistory operation in StoreApi.
 * @export
 * @interface StoreApiUpdateChatHistoryRequest
 */
export interface StoreApiUpdateChatHistoryRequest {
    /**
     * 
     * @type {string}
     * @memberof StoreApiUpdateChatHistory
     */
    readonly namespace: string

    /**
     * 
     * @type {string}
     * @memberof StoreApiUpdateChatHistory
     */
    readonly chat: string

    /**
     * 
     * @type {ApiStoreHistoryPostInput}
     * @memberof StoreApiUpdateChatHistory
     */
    readonly apiStoreHistoryPostInput?: ApiStoreHistoryPostInput
}

/**
 * StoreApi - object-oriented interface
 * @export
 * @class StoreApi
 * @extends {BaseAPI}
 */
export class StoreApi extends BaseAPI implements StoreApiInterface {
    /**
     * Deletes the whole chat for that user and namespace (application tag)
     * @summary Delete chat
     * @param {StoreApiDeleteChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public deleteChat(requestParameters: StoreApiDeleteChatRequest, options?: RawAxiosRequestConfig) {
        return StoreApiFp(this.configuration).deleteChat(requestParameters.namespace, requestParameters.chat, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns messages for that user, namespace (application tag) and chat name
     * @summary Get messages list
     * @param {StoreApiGetChatHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public getChatHistory(requestParameters: StoreApiGetChatHistoryRequest, options?: RawAxiosRequestConfig) {
        return StoreApiFp(this.configuration).getChatHistory(requestParameters.namespace, requestParameters.chat, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retreives message id and model name pairs for the chat
     * @summary Get chat message id and model pairs
     * @param {StoreApiGetChatModelPairsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public getChatModelPairs(requestParameters: StoreApiGetChatModelPairsRequest, options?: RawAxiosRequestConfig) {
        return StoreApiFp(this.configuration).getChatModelPairs(requestParameters.namespace, requestParameters.chat, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retreives list of used models for the chat
     * @summary Get list of used models in the chat
     * @param {StoreApiGetChatUniqueModelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public getChatUniqueModels(requestParameters: StoreApiGetChatUniqueModelsRequest, options?: RawAxiosRequestConfig) {
        return StoreApiFp(this.configuration).getChatUniqueModels(requestParameters.namespace, requestParameters.chat, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns chat names for that user and namespace (application tag)
     * @summary Get chat list
     * @param {StoreApiGetChatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public getChats(requestParameters: StoreApiGetChatsRequest, options?: RawAxiosRequestConfig) {
        return StoreApiFp(this.configuration).getChats(requestParameters.namespace, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates messages for that user, namespace (application tag) and chat name.    Null message will delete a message with such ID.    Messages with the same ID will be overwritten (updated).
     * @summary Update messages
     * @param {StoreApiUpdateChatHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public updateChatHistory(requestParameters: StoreApiUpdateChatHistoryRequest, options?: RawAxiosRequestConfig) {
        return StoreApiFp(this.configuration).updateChatHistory(requestParameters.namespace, requestParameters.chat, requestParameters.apiStoreHistoryPostInput, options).then((request) => request(this.axios, this.basePath));
    }
}

